<nz-spin [nzSpinning]="loading">
  <!-- Toolbar -->
  <div class="tipos-toolbar">
    <button nz-button nzType="dashed" nzSize="small" (click)="onAddTipo()">
      <span nz-icon nzType="plus"></span> Adicionar Tipo
    </button>
    <nz-tag nzColor="blue">{{ tipos.length }} tipo(s)</nz-tag>
  </div>

  <!-- Edit Form -->
  <div #editForm class="tipo-edit-form" *ngIf="editingTipo">
    <nz-card nzSize="small" [nzTitle]="editingTipo?.IDTIPO ? 'Editar Tipo' : 'Novo Tipo'">
      <form nz-form [formGroup]="tipoForm" nzLayout="vertical">
        <div nz-row [nzGutter]="12">
          <div nz-col [nzSpan]="6">
            <nz-form-item>
              <nz-form-label nzRequired>Código do Tipo</nz-form-label>
              <nz-form-control nzErrorTip="Obrigatório">
                <input nz-input formControlName="TIPOS" placeholder="Ex: SALE, REFUND" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="8">
            <nz-form-item>
              <nz-form-label>Descrição</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="DESCRICAO" placeholder="Descrição do tipo" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="10">
            <nz-form-item>
              <nz-form-label>Configuração (IDCONF)</nz-form-label>
              <nz-form-control>
                <nz-select
                  formControlName="IDCONF"
                  nzPlaceHolder="Selecione a configuração"
                  nzAllowClear
                  nzShowSearch>
                  <nz-option
                    *ngFor="let cfg of configsMktpCfg"
                    [nzValue]="cfg.IDCONF"
                    [nzLabel]="cfg.NAME"
                    nzCustomContent>
                    <span>{{ cfg.NAME }}</span>
                    <nz-tag
                      *ngIf="cfg.newMode"
                      nzColor="purple"
                      class="newmode-tag"
                      nz-tooltip
                      nzTooltipTitle="Fluxo do motor novo (NEWMODE='S'). Usa o endpoint /FlowServices/runOnline e recebe __rows/__metadados/__contextoAcao no contexto.">
                      Novo
                    </nz-tag>
                  </nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="4">
            <nz-form-item>
              <nz-form-label
                nz-tooltip
                nzTooltipTitle="Ordem de execução no Processar. Menor roda primeiro; deixe a baixa com o maior número para ela rodar por último.">
                Ordem
              </nz-form-label>
              <nz-form-control>
                <nz-input-number
                  formControlName="ORDEM"
                  [nzMin]="0"
                  [nzStep]="1"
                  nzPlaceHolder="ex: 10"
                  style="width: 100%">
                </nz-input-number>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- Parâmetros DPARA -->
        <div class="dpara-section">
          <div class="dpara-header">
            <span class="dpara-title">
              <span nz-icon nzType="unordered-list"></span>
              Metadados
            </span>
            <button nz-button nzType="dashed" nzSize="small" (click)="onAddParametro()">
              <span nz-icon nzType="plus"></span> Adicionar
            </button>
          </div>

          <div class="dpara-list" *ngIf="parametros.length">
            <div class="dpara-list-header">
              <span class="dpara-col-campo">Campo</span>
              <span class="dpara-col-valor">Valor</span>
              <span class="dpara-col-action"></span>
            </div>
            <div
              class="dpara-row"
              *ngFor="let param of parametros; let i = index; trackBy: trackByIndex">
              <input
                nz-input
                nzSize="small"
                class="dpara-col-campo"
                [(ngModel)]="param.campo"
                [ngModelOptions]="{standalone: true}"
                placeholder="Ex: CODTIPPAR" />
              <input
                nz-input
                nzSize="small"
                class="dpara-col-valor"
                [(ngModel)]="param.valor"
                [ngModelOptions]="{standalone: true}"
                placeholder="Ex: 10" />
              <button
                nz-button
                nzType="text"
                nzDanger
                nzSize="small"
                class="dpara-col-action"
                nz-tooltip="Remover"
                (click)="onRemoveParametro(i)">
                <span nz-icon nzType="minus-circle"></span>
              </button>
            </div>
          </div>

          <nz-empty
            *ngIf="!parametros.length"
            nzNotFoundContent="Nenhum metadado. Clique em Adicionar."
            [nzNotFoundImage]="null"
            class="dpara-empty">
          </nz-empty>
        </div>

        <div class="tipo-form-actions">
          <button nz-button nzSize="small" (click)="onCancelTipo()">Cancelar</button>
          <button nz-button nzType="primary" nzSize="small" [nzLoading]="loading" (click)="onSaveTipo()">
            <span nz-icon nzType="save"></span> Salvar Tipo
          </button>
        </div>
      </form>
    </nz-card>
  </div>

  <!-- Tipos Grid -->
  <nz-table
    #tiposTable
    [nzData]="tipos"
    nzSize="small"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    nzBordered>
    <thead>
      <tr>
        <th nzWidth="100px">Tipo</th>
        <th nzWidth="70px" nzAlign="center" nz-tooltip nzTooltipTitle="Ordem de execução no Processar (menor primeiro; a baixa por último).">Ordem</th>
        <th nzWidth="180px">Descrição</th>
        <th nzWidth="180px">Configuração</th>
        <th>Metadados</th>
        <th nzWidth="90px" nzAlign="center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let tipo of tiposTable.data">
        <td>
          <nz-tag nzColor="purple">{{ tipo.TIPOS }}</nz-tag>
        </td>
        <td nzAlign="center">
          <nz-tag *ngIf="tipo.ORDEM != null" nzColor="blue">{{ tipo.ORDEM }}</nz-tag>
          <span *ngIf="tipo.ORDEM == null" class="text-muted">—</span>
        </td>
        <td>{{ tipo.DESCRICAO }}</td>
        <td>{{ getConfigName(tipo.IDCONF) }}</td>
        <td>
          <span class="param-summary" *ngIf="getParamCount(tipo) > 0">
            <nz-tag *ngFor="let p of parseParametros(tipo.PARAMETROS)" nzColor="geekblue">
              {{ p.campo }}={{ p.valor }}
            </nz-tag>
          </span>
          <span *ngIf="getParamCount(tipo) === 0" class="no-params">—</span>
        </td>
        <td nzAlign="center">
          <button nz-button nzType="text" nzSize="small" nz-tooltip="Editar" (click)="onEditTipo(tipo)">
            <span nz-icon nzType="edit"></span>
          </button>
          <button nz-button nzType="text" nzDanger nzSize="small" nz-tooltip="Excluir" (click)="onDeleteTipo(tipo)">
            <span nz-icon nzType="delete"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <nz-empty *ngIf="!tipos.length && !loading" nzNotFoundContent="Nenhum tipo cadastrado"></nz-empty>
</nz-spin>
